import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types'; // @ts-expect-error

import { mergeDeepRight } from 'ramda'; // Extracted directly from https://github.com/acdlite/recompose/blob/master/src/packages/recompose/getDisplayName.js
// The motivation is to stop having recompose around as a dependency

var getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
};

export default function withProvisionalOverrideFromContext(Target) {
  var name = getDisplayName(Target);

  var WithPropsFromContext = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(WithPropsFromContext, _React$PureComponent);

    var _super = _createSuper(WithPropsFromContext);

    function WithPropsFromContext() {
      _classCallCheck(this, WithPropsFromContext);

      return _super.apply(this, arguments);
    }

    _createClass(WithPropsFromContext, [{
      key: "render",
      value: function render() {
        var Override = this.context[name];

        if (typeof Override === 'function') {
          return /*#__PURE__*/React.createElement(Override, this.props);
        } else if (Override != null) {
          return /*#__PURE__*/React.createElement(Target, mergeDeepRight(this.props, Override));
        }

        return /*#__PURE__*/React.createElement(Target, this.props);
      }
    }]);

    return WithPropsFromContext;
  }(React.PureComponent); // @ts-expect-error


  WithPropsFromContext.contextTypes = _defineProperty({}, name, PropTypes.any); // @ts-expect-error

  WithPropsFromContext.displayName = name;
  return WithPropsFromContext;
}
//# sourceMappingURL=index.js.map